<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-if="readonly"
          name="date_from"
          :value="form.date_from | dateFormat"
          :label="`${$t('ITEM.DATE_FROM')} *`"
          :error-messages="errors.date_from"
          prepend-inner-icon="mdi-calendar"
          readonly
        ></v-text-field>

        <v-menu
          v-else
          ref="menuDateFrom"
          min-width="290px"
          transition="scale-transition"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              name="date_from"
              autocomplete="nope"
              prepend-inner-icon="mdi-calendar"
              :value="form.date_from | dateFormat"
              :label="`${$t('ITEM.DATE_FROM')} *`"
              :readonly="readonly"
              :rules="getRulesByName('date_from')"
              :error-messages="errors.date_from"
              clearable
              v-bind="attrs"
              v-on="on"
              @click:clear="form.date_from = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="form.date_from"
            first-day-of-week="1"
            @change="setDateFrom"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-if="readonly"
          name="date_to"
          :value="form.date_to | dateFormat"
          :label="`${$t('ITEM.DATE_TO')} *`"
          :error-messages="errors.date_to"
          prepend-inner-icon="mdi-calendar"
          readonly
        ></v-text-field>

        <v-menu
          v-else
          ref="menuDateTo"
          min-width="290px"
          transition="scale-transition"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              name="date_to"
              autocomplete="nope"
              prepend-inner-icon="mdi-calendar"
              :value="form.date_to | dateFormat"
              :label="`${$t('ITEM.DATE_TO')} *`"
              :readonly="readonly"
              :rules="getRulesByName('date_to')"
              :error-messages="errors.date_to"
              clearable
              v-bind="attrs"
              v-on="on"
              @click:clear="form.date_to = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="form.date_to"
            :min="form.date_from"
            first-day-of-week="1"
            @change="setDateTo"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { dateFormat } from '@/modules/_global/filters';
import { notEmpty } from '@/modules/_global/variables/rules';

export default {
  name: 'BookingReservationDayForm',

  filters: {
    dateFormat
  },

  mixins: [formEditable],

  data() {
    return {
      form: {
        date_from: null,
        date_to: null
      },
      rules: {
        date_from: [notEmpty],
        date_to: [notEmpty]
      }
    };
  },

  methods: {
    setDateFrom(date) {
      this.$refs.menuDateFrom.save(date);
      this.updateValue('date_from', date);
    },

    setDateTo(date) {
      this.$refs.menuDateTo.save(date);
      this.updateValue('date_to', date);
    }
  }
};
</script>
